module.exports = __webpack_public_path__ + "static/logo--black.2d520349.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo--black.png
// module id = 467
// module chunks = 114276838955818